import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import $ from 'jquery';
import AuthService from '../../../../controllers/AuthService';
import UserService from '../../../../controllers/UserService';

const HomeroomSummary = props => {

    const filterYear = props.filterYear ?? null
    const filterTerm = props.filterTerm ?? null
    const user = AuthService.getCurrentUser();
    const [pClassCount, setPClassCount] = useState(0);
    const [sClassCount, setSClassCount] = useState(0);

    useEffect(() => {
        if (!filterYear || !filterTerm) {
            console.log('Cannot read props')
            return;
        }

        loadAPI("SECONDARY_SCHOOL")
        loadAPI("PRIMARY_SCHOOL")

    }, [filterYear, filterTerm])

    const loadAPI = async (grade) => {
        const filter = {
            "domain": user.domain.name,
            "year": filterYear,
            "term": filterTerm,
            "grade": grade,
        };
        UserService.activitiesGradeYearAll(filter).then((response) => {
            const dataAll = response.data.data
            console.log(dataAll)
            let tempData = [null, null, null, null, null, null];
            let countActivity = 0
            let countTeacher = 0
            let countStudent = 0
            for (let i = 0; i < 6; i++) {
                if (dataAll[i]) {
                    countActivity += dataAll[i].totalActivities
                    countTeacher += dataAll[i].totalTeachers
                    countStudent += dataAll[i].totalStudents

                    var tempIndex = dataAll[i].gradeYear - 1;

                    tempData[tempIndex] = dataAll[i];
                }
            }

            if (grade === "SECONDARY_SCHOOL") {
                setSClassCount(countActivity)
            } else {
                setPClassCount(countActivity)

            }
        });
    }

    const showHideSection = (section) => {
        console.log(section);
        var targetID = $('#' + section);
        var tragetClass = $('.' + section);
        if (targetID.hasClass('showhide-red')) {
            targetID.removeClass('showhide-red');
            targetID.addClass('showhide-green');
            tragetClass.hide();
        } else {
            targetID.removeClass('showhide-green');
            targetID.addClass('showhide-red');
            tragetClass.show();
        }

    }

    return (
        <>
            <Row className="font-sarabun mt-3 mb-3">
                <Col xs={12} className="text-center">
                    <h2 className="font-sarabun-bold mb-0">
                        ผลการทำกิจกรรม Homeroom
                    </h2>
                    <button className="btn-showhide border-gray showhide-red d-none d-lg-inline" id="showHideHomeroom" onClick={() => showHideSection('showHideHomeroom')}> </button>
                </Col>
            </Row>
            <Row className="font-sarabun mt-3 mx-1 border-lightness5-blue showHideHomeroom mb-custom-x2" style={{ "borderRadius": "7px" }}>

                <Col xs={6} className="bg-lightness5-blue py-3">
                    <Row>
                        <Col xs={5} className="text-right">
                            <img src="/images/icons/book_blue.png" height="45" className="ml-2" />
                        </Col>
                        <Col xs={7}>
                            <h4 className="mb-0 s12">จำนวนครั้งกิจกรรม</h4>
                            <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-domain-homeroom-total-count">{pClassCount + sClassCount || '-'} รอบ</h3>
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} style={{ "borderLeft": 'solid 1px #D5E3FB' }} className="bg-lightness5-blue py-3"><Row>
                    <Col xs={5} className="text-right">
                        <img src="/images/icons/stopwatch_blue.png" width="45" />
                    </Col>
                    <Col xs={7}>
                        <h4 className="mb-0 s12">คิดเป็นช่วงเวลาเชิงบวก</h4>
                        <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-domain-homeroom-total-minute">{(pClassCount + sClassCount) * 20}  นาที</h3>
                    </Col>
                </Row>
                </Col>
            </Row>
        </>
    )

}

export default HomeroomSummary